import type { ClientLegalText } from '@DigitaleDoerfer/digitale-doerfer-api';

export const PrivacyRoute = {
  Legal: 'legal',
  LegalText: 'legalText',
  DeleteAccount: 'delete-account'
} as const;

export type PrivacyRoute = (typeof PrivacyRoute)[keyof typeof PrivacyRoute];

export type PrivacyParam = {
  [PrivacyRoute.Legal]: undefined;
  [PrivacyRoute.LegalText]: {
    name: ClientLegalText['name'];
    id: ClientLegalText['id'];
  };
  [PrivacyRoute.DeleteAccount]: undefined;
};
